import * as angular from 'angular';
import {IController} from "angular";

export class FulfillmentLinkComponent implements IController {
  id: string;
  displayId?: string;
  showTooltip: boolean;

  public canCopy: boolean;

  /* @ngInject */
  constructor(private $state) {

  }

  $onInit() {
    if (!this.displayId) {
      this.displayId = this.id;
    }
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLink', {
    bindings: {
      id: '<',
      displayId: '<?',
      showTooltip:'<?'
    },
    template: require('./fulfillment-link.html').default,
    controller: FulfillmentLinkComponent
  });
